import React from 'react';
import {
  Box,
  Card,
  Typography,
  CardContent,
  TextField,
  DialogActions,
  Button,
} from '@mui/material';
import { post } from '../api/api';

export default function NewItemBox(props) {
  React.useEffect(() => { }, []);

  const obj = {}
  props.resource.actions.add.itemProperties.map((a) => {
    let value = (a.defaultValue !== undefined ? a.defaultValue : '');
    if(a.isArray) value = value.split();
    obj[a.name] = value;
    return value;
  });
  
  const [newItem, setNewItem] = React.useState(obj);

  const [setLoading] = React.useState(true);

  const handleAdd = () => {
    setLoading(true);
    post(props.resource.link, newItem, {
      token: props.auth.token,
    })
      .then((res) => {
        props.setAlert({ message: 'Item added', severity: 'info', open: true });
        setLoading(false);
      })
      .catch((err) => {
        props.setAlert({ message: err.message, severity: 'error', open: true });
        setLoading(false);
      });
  };

  const handleInputChange = (e) => {
    let value = e.currentTarget.value;
    // if (props.resource.actions.add.itemProperties[e.currentTarget.id].isArray) value = value.split();
    setNewItem({ ...newItem, [e.currentTarget.id]: value });
  }

  return (
    <Box sx={{ margin: '0 auto' }}>
      <Typography variant="h4" noWrap component="div">
        New {props.resource.name}
      </Typography>
      <Card
        sx={{
          textAlign: 'left',
          display: 'grid',
          gridTemplateRows: '1fr',
          padding: '20px',
        }}
      >
        {Object.entries(props.resource.actions.add.itemProperties).map(([key, item]) => (
          <CardContent>
            <TextField id={item.name} label={item.name} variant="outlined" onChange={handleInputChange} type={item.type ? item.type : 'text'} disabled={item.disabled ? true : false} defaultValue={item.defaultValue !== undefined ? item.defaultValue : ''}/>
          </CardContent>
        ))}
      </Card>
      <DialogActions>
        <Button onClick={handleAdd} variant="contained" style={{ marginTop: '1em', fontSize: 'larger', color: '#fff' }}>Add</Button>
      </DialogActions>
    </Box>
  );
}
